<div *ngIf="!!customer">
  <div class="row mb-4">
    <div class="col d-flex flex-direction-row justify-content-between">
      <h3>{{ customer.name }}</h3>
      <lib-action-btn [item]="customer" [config]="configService"></lib-action-btn>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <lib-gung-tabset justify="fill" *ngIf="!!customer">
        <!-- DELIVERY_ADDRESS for CAPSTONE -->
        <lib-gung-tab [title]="'DELIVERY_ADDRESS' | translate">
          <ng-template libGungTabContent>
            <div class="row pt-4">
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label class="control-label" for="nameInput" translate>FR_FTGNAMN</label>
                  <input
                    class="form-control"
                    name="nameInput"
                    type="text"
                    [(ngModel)]="customer.extra.fr.ftgnamn"
                    disabled
                  />
                </div>

                <div class="form-group">
                  <label class="control-label" for="address" translate>FR_FTGPOSTADR5</label>
                  <input
                    class="form-control"
                    name="address"
                    type="text"
                    [(ngModel)]="customer.extra.fr.ftgpostadr5"
                    disabled
                  />
                </div>

                <div class="form-group">
                  <label class="control-label" for="city" translate>FR_FTGPOSTLEVADR3</label>
                  <input
                    class="form-control"
                    name="city"
                    type="text"
                    [(ngModel)]="customer.extra.fr.ftgpostlevadr3"
                    disabled
                  />
                </div>

                <div class="form-group">
                  <label class="control-label" for="postalCode" translate>FR_FTGPOSTNR</label>
                  <input
                    class="form-control"
                    name="postalCode"
                    type="text"
                    [(ngModel)]="customer.extra.fr.ftglevpostnr"
                    disabled
                  />
                </div>

                <div class="form-group">
                  <label class="control-label" for="city" translate>FR_LANDSKOD</label>
                  <input
                    class="form-control"
                    name="city"
                    type="text"
                    [(ngModel)]="customer.extra.fr.landskod"
                    disabled
                  />
                </div>
              </div>
              <div class="col-12 col-md-6">
                <!-- <div class="form-group">
                        <label class="control-label" for="contact" translate>CONTACT_PERSON_NAME</label>
                        <input class="form-control" name="contact" type="text" disabled />
                      </div> -->

                <div class="form-group">
                  <label class="control-label" for="email" translate>EMAIL</label>
                  <input
                    class="form-control"
                    name="email"
                    type="text"
                    [(ngModel)]="customer.extra.kus.q_email_invoice"
                    disabled
                  />
                </div>

                <div class="form-group">
                  <label class="control-label" for="phone" translate>PHONE</label>
                  <input class="form-control" name="phone" type="text" [(ngModel)]="customer.extra.fr.comnr" disabled />
                </div>
              </div>
            </div>
          </ng-template>
        </lib-gung-tab>
        <lib-gung-tab [title]="'BILLING_INFORMATION' | translate">
          <ng-template libGungTabContent>
            <div class="row pt-4">
              <div class="col">
                <div class="form-group">
                  <label class="control-label" for="city" translate>NAME</label>
                  <input
                    class="form-control"
                    name="city"
                    type="text"
                    [(ngModel)]="customer.extra._billing.ftgnamn"
                    disabled
                  />
                </div>
                <div class="form-group">
                  <label class="control-label" for="city" translate>FR_FTGPOSTADR2_INVOICE</label>
                  <input
                    class="form-control"
                    name="city"
                    type="text"
                    [(ngModel)]="customer.extra._billing.ftgpostadr2"
                    disabled
                  />
                </div>
                <div class="form-group">
                  <label class="control-label" for="address" translate>FR_FTGPOSTADR3_INVOICE</label>
                  <input
                    class="form-control"
                    name="address"
                    type="text"
                    [(ngModel)]="customer.extra._billing.ftgpostadr3"
                    disabled
                  />
                </div>
                <div class="form-group">
                  <label class="control-label" for="city" translate>FR_FTGPOSTNR_INVOICE</label>
                  <input
                    class="form-control"
                    name="city"
                    type="text"
                    [(ngModel)]="customer.extra._billing.ftgpostnr"
                    disabled
                  />
                </div>
                <div class="form-group">
                  <label class="control-label" for="city" translate>FR_LANDSKOD</label>
                  <input
                    class="form-control"
                    name="city"
                    type="text"
                    [(ngModel)]="customer.extra._billing.landskod"
                    disabled
                  />
                </div>
              </div>
              <div class="col">
                <div *ngIf="isCapstone">
                  <div class="form-group">
                    <label class="control-label" for="phone" translate>KUS_KUNDRABATT</label>
                    <input
                      class="form-control"
                      name="phone"
                      type="text"
                      [(ngModel)]="customer.extra.kus.kundrabatt"
                      disabled
                    />
                  </div>
                  <div class="form-group">
                    <label class="control-label" for="kundklass" translate>REF_KUNDKLASS</label>
                    <lib-meta-select-input
                      [suppressLabel]="true"
                      [(ngModel)]="customer.extra._billingCustomer.extra.kus.kundklass"
                      table="x1kk"
                      metaId="kundklass"
                      metaDisplay="kundklassbeskr"
                      [disabled]="true"
                    >
                    </lib-meta-select-input>
                  </div>
                  <div class="form-group">
                    <lib-meta-select-input
                      [(ngModel)]="customer.extra._billingCustomer.extra.kus.kundkategorikod"
                      table="x1k"
                      metaId="kundkategorikod"
                      metaDisplay="kundkatbeskr"
                      [disabled]="true"
                    >
                    </lib-meta-select-input>
                  </div>
                  <div class="form-group">
                    <lib-meta-select-input
                      [(ngModel)]="customer.extra._billingCustomer.extra.kus.betkod"
                      table="x2"
                      metaId="betkod"
                      metaDisplay="betvillbeskr"
                      [disabled]="true"
                    >
                    </lib-meta-select-input>
                  </div>
                  <div class="form-group">
                    <label class="control-label" for="orgnr" translate>ORG_NR</label>
                    <input
                      class="form-control"
                      name="orgnr"
                      type="text"
                      [(ngModel)]="customer.extra._billingCustomer.extra.fr.orgnr"
                      disabled
                    />
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </lib-gung-tab>
        <lib-gung-tab [title]="'CONDITIONS' | translate">
          <ng-template libGungTabContent>
            <div class="row mt-4">
              <div class="col">
                <lib-meta-select-input
                  [(ngModel)]="customer.extra.kus.levvillkkod"
                  table="x2e"
                  metaId="levvillkkod"
                  metaDisplay="levvillkbeskr"
                  [disabled]="true"
                ></lib-meta-select-input>
                <lib-meta-select-input
                  [(ngModel)]="customer.extra.kus.levsattkod"
                  table="x2f"
                  metaId="levsattkod"
                  metaDisplay="levsattbeskr"
                  [disabled]="true"
                ></lib-meta-select-input>
                <lib-meta-select-input
                  [(ngModel)]="customer.extra.kus.saljare"
                  table="salj"
                  metaId="saljare"
                  metaDisplay="saljarenamn"
                  [disabled]="true"
                ></lib-meta-select-input>
                <lib-meta-select-input
                  [(ngModel)]="customer.extra.kus.valkod"
                  table="xx"
                  metaId="valkod"
                  metaDisplay="valkod"
                  [disabled]="true"
                ></lib-meta-select-input>
                <lib-gung-text-input
                  [(ngModel)]="customer.extra.kus.kundrabatt"
                  renderStatic="true"
                  gungTranslate="ORDER_ID"
                  extraInputClass="form-control p-3 border"
                ></lib-gung-text-input>
              </div>
              <div class="col">
                <lib-meta-select-input
                  [(ngModel)]="customer.extra.kus.betkod"
                  table="x2"
                  metaId="betkod"
                  metaDisplay="betvillbeskr"
                  [disabled]="true"
                ></lib-meta-select-input>
                <lib-meta-select-input
                  [(ngModel)]="customer.extra.kus.kundkategorikod"
                  table="x1k"
                  metaId="kundkategorikod"
                  metaDisplay="kundkatbeskr"
                  [disabled]="true"
                ></lib-meta-select-input>
                <lib-meta-select-input
                  [(ngModel)]="customer.extra.kus.prislista"
                  table="prh"
                  metaId="prislista"
                  metaDisplay="prislistabeskr"
                  [disabled]="true"
                ></lib-meta-select-input>
                <lib-meta-select-input
                  [(ngModel)]="customer.extra.kus.momskod"
                  table="x1"
                  metaId="momskod"
                  metaDisplay="momsbeskrivning"
                  [disabled]="true"
                ></lib-meta-select-input>
                <lib-meta-select-input
                  [(ngModel)]="customer.extra.kus.kundklass"
                  gungTranslate="REF_KUNDKLASS"
                  table="x1kk"
                  metaId="kundklass"
                  metaDisplay="kundklassbeskr"
                  [disabled]="true"
                ></lib-meta-select-input>
              </div>
            </div>
          </ng-template>
        </lib-gung-tab>
        <lib-gung-tab [title]="'CONTACTS' | translate">
          <ng-template libGungTabContent>
            <div class="row pt-4">
              <div class="col">
                <lib-customer-contact-list></lib-customer-contact-list>
              </div>
            </div>
          </ng-template>
        </lib-gung-tab>
        <lib-gung-tab [title]="'ORDERS' | translate">
          <ng-template libGungTabContent>
            <div class="row pt-4">
              <div class="col">
                <lib-order-list></lib-order-list>
              </div>
            </div>
          </ng-template>
        </lib-gung-tab>
        <lib-gung-tab [title]="'INVOICES' | translate">
          <ng-template libGungTabContent>
            <div class="row pt-4">
              <div class="col">
                <ref-ref-jeeves-invoice-list></ref-ref-jeeves-invoice-list>
              </div>
            </div>
          </ng-template>
        </lib-gung-tab>
      </lib-gung-tabset>
    </div>
  </div>
</div>
